// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import type { ReactNode } from "react";

export interface BackAction {
  href: string;
  label: string;
}

/**
 * The page frame every route uses: s-page with its heading and, on sub-pages, the back
 * action in the title bar (BFS: every sub-page has a back button).
 */
export function Page({ heading, back, children }: { heading: string; back?: BackAction; children: ReactNode }) {
  return (
    <s-page heading={heading}>
      {back && (
        <s-link slot="breadcrumb-actions" href={back.href}>
          {back.label}
        </s-link>
      )}
      {children}
    </s-page>
  );
}
